"use strict";

var _index = require("./index");

var gdpr = new _index.WDHGDPR();
gdpr.run();